import React from "react";
import { NSChartDoughnut, NSLabel, NSRow, NSSection } from "namirasoft-site-react";
import { NSARouterMakerProps } from "namirasoft-account-react";
import { JobArrangerLayout } from "../JobArrangerLayout";
import { JobArrangerProps } from "../JobArrangerProps";
import { DashboardRow } from "../rows/DashboardRow";
import Style from "./DashboardPage.module.css";
import { JobArrangerMenus } from "../JobArrangerMenus";

interface DashboardPageProps extends NSARouterMakerProps, JobArrangerProps { }

interface DashboardPageState 
{
	row: DashboardRow | null;
	status: DataSet | null;
	platform: DataSet | null;
	reason: DataSet | null;
}

interface DataSet
{
	labels: string[];
	values: number[];
	colors: string[],
}

export default class DashboardPage extends React.Component<DashboardPageProps, DashboardPageState>
{
	private static colors_job_status: { [job_status: string]: string } = {
		"BlackList": "#555555",
		"WhiteList": "#71C4E6",
		"Applied": "#00AAFF",
		"Replied": "#c5b919",
		"Interviewed": "#5FA160",
		"Rejected": "#FF4444",
		"Hired": "#274228"
	};

	private static colors_background: string[] = [
		"#FF5733",
		"#42A5F5",
		"#FFC107",
		"#8BC34A",
		"#FF5722",
		"#673AB7",
		"#E91E63",
		"#4CAF50",
		"#FF9800",
		"#9C27B0",
		"#2196F3",
		"#FFEB3B",
		"#FF4081",
		"#00BCD4",
		"#CDDC39",
		"#795548",
		"#FF5722",
		"#F44336",
		"#3F51B5",
		"#009688",
	];

	constructor(props: DashboardPageProps)
	{
		super(props);

		this.state = {
			row: null,
			status: null,
			platform: null,
			reason: null
		};
	}
	override componentDidMount(): void
	{
		this.props.servers.job_arranger.user.Dashboard().then((dashboard) =>
		{
			this.setState({ row: dashboard });
		}).catch(() => { });
	}

	override render()
	{
		let dataset_status: DataSet | null = null;
		let dataset_platform: DataSet | null = null;
		if (this.state.row)
		{
			if (this.state.row.byStatus.length > 0)
				dataset_status = {
					labels: this.state.row.byStatus.map(x => x.name),
					values: this.state.row.byStatus.map(x => x.count),
					colors: this.state.row.byStatus.map((x, index) => DashboardPage.colors_job_status[x.name] ?? DashboardPage.colors_background[index % DashboardPage.colors_background.length])
				};
			if (this.state.row.byPlatform.length > 0)
				dataset_platform = {
					labels: this.state.row.byPlatform.map(x => x.name),
					values: this.state.row.byPlatform.map(x => x.count),
					colors: this.state.row.byPlatform.map((_, index) => DashboardPage.colors_background[index % DashboardPage.colors_background.length])
				};
		}

		return (
			<JobArrangerLayout {...this.props}
				action={{
					title: "Dashborad",
					description: "Comprehensive reports, status-based and platform-based, to help you stay informed about your job search progress and activities.",
					menus: { "Store": [JobArrangerMenus.download()] }
				}}
			>
				<div className={Style.dashboard} >
					<div className={`row ${Style.parent_chart}`}>
						{
							dataset_status &&
							<div className="col-md-4 mx-auto">
								<NSChartDoughnut
									labels={dataset_status.labels}
									datas={dataset_status.values}
									backgroundColors={dataset_status.colors}
									borderWidth={1}
									title="Status"
								/>
							</div>
						}
						{
							dataset_platform &&
							<div className="col-md-4 mx-auto">
								<NSChartDoughnut
									labels={dataset_platform.labels}
									datas={dataset_platform.values}
									backgroundColors={dataset_platform.colors}
									borderWidth={1}
									title="Platform"
								/>
							</div>
						}
						{
							!dataset_status && !dataset_platform &&
							<NSSection>
								<NSRow>
									<NSLabel
										title="There is no data yet to show the dashboard."
									>
										<></>
									</NSLabel>
								</NSRow>
							</NSSection>
						}
					</div>
				</div >
			</JobArrangerLayout>
		);
	}
}